import React from 'react';
import KnowledgeBaseBannerView from './KnowledgeBaseBannerView.tsx';
import type {
	KnowledgeBaseReadinessState,
	KnowledgeBaseReadinessSummary,
} from '@/hooks/house/documents/knowledgeBaseReadiness';

interface KnowledgeBaseBannerProps {
	onDismiss: () => void;
	onViewRecords?: () => void;
	progressValue: number;
	state: KnowledgeBaseReadinessState;
	variant?: 'dashboard' | 'records';
	summary?: KnowledgeBaseReadinessSummary | null;
}

const KnowledgeBaseBanner: React.FC<KnowledgeBaseBannerProps> = (props) => {
	const { onDismiss, onViewRecords, progressValue, state, variant = 'dashboard', summary } = props;

	return (
		<KnowledgeBaseBannerView
			onDismiss={onDismiss}
			onViewRecords={onViewRecords}
			progressValue={progressValue}
			state={state}
			variant={variant}
			summary={summary}
		/>
	);
};

export default KnowledgeBaseBanner;
